/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Crawler API
 * Site scaper API interface
 * OpenAPI spec version: 1.0
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse } from "axios";

import type {
  AuthDto,
  BooleanResponse,
  ContactDto,
  CrawlerResponseDto,
  CrawlerSettingsInputDto,
  CreateUserDto,
  ForgotPasswordDto,
  GetExportWithFormatWithId200,
  GetExportWithFormatWithIdParams,
  GetFinishedParams,
  PinResponseDto,
  PinVerifyDto,
  ResendPinDto,
  ResetPasswordDto,
  SendCustomEmailDto,
  SendSiteContactEmailDto,
  SendTemplateEmailDto,
  SiteDto,
  StatusResponseDto,
  TokenResponseDto,
  UpdateUserDataDto,
  UpdateUserDto,
  UserDto,
} from "./model";

export const getCrawlerAPI = () => {
  const getFinished = <TData = AxiosResponse<void>>(
    params: GetFinishedParams,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/app/finished`, {
      ...options,
      params: { ...params, ...options?.params },
    });
  };

  const postInit = <TData = AxiosResponse<CrawlerResponseDto>>(
    crawlerSettingsInputDto: CrawlerSettingsInputDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/crawler/init`, crawlerSettingsInputDto, options);
  };

  const getSites = <TData = AxiosResponse<SiteDto[]>>(
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/crawler/sites`, options);
  };

  const getSiteWithId = <TData = AxiosResponse<SiteDto>>(
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/crawler/site/${id}`, options);
  };

  const deleteDeleteWithId = <TData = AxiosResponse<SiteDto>>(
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.delete(`/crawler/delete/${id}`, options);
  };

  const postAbortWithId = <TData = AxiosResponse<SiteDto>>(
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/crawler/abort/${id}`, undefined, options);
  };

  const getExportWithFormatWithId = <
    TData = AxiosResponse<GetExportWithFormatWithId200>,
  >(
    format: string,
    id: string,
    params: GetExportWithFormatWithIdParams,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/crawler/export/${format}/${id}`, {
      ...options,
      params: { ...params, ...options?.params },
    });
  };

  const postCreateUser = <TData = AxiosResponse<void>>(
    createUserDto: CreateUserDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/users/create-user`, createUserDto, options);
  };

  const postContact = <TData = AxiosResponse<StatusResponseDto>>(
    contactDto: ContactDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/users/contact`, contactDto, options);
  };

  const getUsers = <TData = AxiosResponse<UserDto[]>>(
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/users/users`, options);
  };

  const getUserWithId = <TData = AxiosResponse<UserDto>>(
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/users/user/${id}`, options);
  };

  const patchUserWithId = <TData = AxiosResponse<UserDto>>(
    id: string,
    updateUserDto: UpdateUserDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.patch(`/users/user/${id}`, updateUserDto, options);
  };

  const deleteUserWithId = <TData = AxiosResponse<UserDto>>(
    id: string,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.delete(`/users/user/${id}`, options);
  };

  const postSendTemplate = <TData = AxiosResponse<void>>(
    sendTemplateEmailDto: SendTemplateEmailDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/email/send-template`, sendTemplateEmailDto, options);
  };

  const postSend = <TData = AxiosResponse<void>>(
    sendCustomEmailDto: SendCustomEmailDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/email/send`, sendCustomEmailDto, options);
  };

  const postSendSiteContactEmail = <TData = AxiosResponse<BooleanResponse>>(
    sendSiteContactEmailDto: SendSiteContactEmailDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(
      `/email/send-site-contact-email`,
      sendSiteContactEmailDto,
      options,
    );
  };

  const postSignup = <TData = AxiosResponse<PinResponseDto>>(
    createUserDto: CreateUserDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/auth/signup`, createUserDto, options);
  };

  const patchUpdateData = <TData = AxiosResponse<UserDto>>(
    updateUserDataDto: UpdateUserDataDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.patch(`/auth/update-data`, updateUserDataDto, options);
  };

  const postVerifyPin = <TData = AxiosResponse<TokenResponseDto>>(
    pinVerifyDto: PinVerifyDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/auth/verify-pin`, pinVerifyDto, options);
  };

  const postResendPin = <TData = AxiosResponse<PinResponseDto>>(
    resendPinDto: ResendPinDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/auth/resend-pin`, resendPinDto, options);
  };

  const postForgotPassword = <TData = AxiosResponse<StatusResponseDto>>(
    forgotPasswordDto: ForgotPasswordDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/auth/forgot-password`, forgotPasswordDto, options);
  };

  const postResetPassword = <TData = AxiosResponse<StatusResponseDto>>(
    resetPasswordDto: ResetPasswordDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/auth/reset-password`, resetPasswordDto, options);
  };

  const getMe = <TData = AxiosResponse<UserDto>>(
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/auth/me`, options);
  };

  const postSignin = <TData = AxiosResponse<TokenResponseDto>>(
    authDto: AuthDto,
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.post(`/auth/signin`, authDto, options);
  };

  const getLogout = <TData = AxiosResponse<void>>(
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/auth/logout`, options);
  };

  const getRefresh = <TData = AxiosResponse<TokenResponseDto>>(
    options?: AxiosRequestConfig,
  ): Promise<TData> => {
    return axios.get(`/auth/refresh`, options);
  };

  return {
    getFinished,
    postInit,
    getSites,
    getSiteWithId,
    deleteDeleteWithId,
    postAbortWithId,
    getExportWithFormatWithId,
    postCreateUser,
    postContact,
    getUsers,
    getUserWithId,
    patchUserWithId,
    deleteUserWithId,
    postSendTemplate,
    postSend,
    postSendSiteContactEmail,
    postSignup,
    patchUpdateData,
    postVerifyPin,
    postResendPin,
    postForgotPassword,
    postResetPassword,
    getMe,
    postSignin,
    getLogout,
    getRefresh,
  };
};
export type GetFinishedResult = AxiosResponse<void>;
export type PostInitResult = AxiosResponse<CrawlerResponseDto>;
export type GetSitesResult = AxiosResponse<SiteDto[]>;
export type GetSiteWithIdResult = AxiosResponse<SiteDto>;
export type DeleteDeleteWithIdResult = AxiosResponse<SiteDto>;
export type PostAbortWithIdResult = AxiosResponse<SiteDto>;
export type GetExportWithFormatWithIdResult =
  AxiosResponse<GetExportWithFormatWithId200>;
export type PostCreateUserResult = AxiosResponse<void>;
export type PostContactResult = AxiosResponse<StatusResponseDto>;
export type GetUsersResult = AxiosResponse<UserDto[]>;
export type GetUserWithIdResult = AxiosResponse<UserDto>;
export type PatchUserWithIdResult = AxiosResponse<UserDto>;
export type DeleteUserWithIdResult = AxiosResponse<UserDto>;
export type PostSendTemplateResult = AxiosResponse<void>;
export type PostSendResult = AxiosResponse<void>;
export type PostSendSiteContactEmailResult = AxiosResponse<BooleanResponse>;
export type PostSignupResult = AxiosResponse<PinResponseDto>;
export type PatchUpdateDataResult = AxiosResponse<UserDto>;
export type PostVerifyPinResult = AxiosResponse<TokenResponseDto>;
export type PostResendPinResult = AxiosResponse<PinResponseDto>;
export type PostForgotPasswordResult = AxiosResponse<StatusResponseDto>;
export type PostResetPasswordResult = AxiosResponse<StatusResponseDto>;
export type GetMeResult = AxiosResponse<UserDto>;
export type PostSigninResult = AxiosResponse<TokenResponseDto>;
export type GetLogoutResult = AxiosResponse<void>;
export type GetRefreshResult = AxiosResponse<TokenResponseDto>;
